import { React } from '@gasbuddy/react';
import moment from 'moment';
import Style from './terminal.css';

function changeClass({ currentTarget }, style, isOn) {
  currentTarget.classList[isOn ? 'add' : 'remove'](style);
}

function kvPrint(k, v) {
  if (k === 'c') {
    return (
      <span key="c">
        <a target="logDetail" href={`/system/logs/correlationId/${moment().utc().format('YYYY.MM.DD')}/${encodeURIComponent(v)}`}>
c=
          {v}
        </a>
&nbsp;
      </span>
    );
  }
  if (typeof v === 'object') {
    return (
      <span key={k}>
        {k}
=
        {JSON.stringify(v)}
&nbsp;
      </span>
    );
  }
  return (
    <span key={k}>
      {k}
=
      {v}
&nbsp;
    </span>
  );
}

export class Terminal extends React.Component {
  componentDidUpdate() {
    const { autoscroll } = this.props;
    if (this.cursor && autoscroll) {
      this.cursor.scrollIntoView({ behavior: 'smooth' });
    }
  }

  props: {
    lines: Array<Object>,
    autoscroll: boolean,
  };

  render() {
    const { lines = [] } = this.props;
    return (
      <div className={Style.md}>
        <pre>
          {lines.map(({ ts, ctr, message, label, level, '@timestamp': tsdiscard, ...rest }) => (
            <div
              key={`${ts}-${ctr}`}
              className={Style[level]}
              onMouseOver={e => changeClass(e, Style.hov, true)}
              onFocus={e => changeClass(e, Style.hov, true)}
              onMouseOut={e => changeClass(e, Style.hov, false)}
              onBlur={e => changeClass(e, Style.hov, false)}
            >
              <code>
                {`${moment(ts).format('HH:mm:ss.SSS')}#${ctr || ''}`}
                {' '}
                {label}
                {' '}
                {String(message)}
                {' '}
                {Object.entries(rest).map(([k, v]) => kvPrint(k, v))}
              </code>
            </div>
          ))}
          <code className={Style.input} ref={(i) => { this.cursor = i; }} />
        </pre>
      </div>
    );
  }
}
